
import httpRequest from './httpRequest'
import commonJs from './common-js'
import {COMMON_JP} from './custom_language_jp'
import $cErrorDialog from '../components/Dialog/cErrorDialog'

/**
 * 检查text 是否包含了汉字
 * @param {*} text  检测内容
 * @returns Object
 */
const checkJpText=(text)=>{
    return new Promise(resolve => {
        if(text){
          httpRequest.post('/common/check_jp_text',{TEXT:text}).then((res)=>{
            if(res.data.STATUS == 'OK'){
              resolve({status:false,msg:''});
            }else{
              resolve({status:true,msg:res.data.ERROR.MESSAGE});
            }
          })
        }else{
          resolve({status:false,msg:''});
        }
      })
}

const getInit = (keyString) => {
  return new Promise(resolve => {
    httpRequest.post('/init').then((res)=>{
      if(res.data.STATUS == 'OK'){
        if(keyString){
          if(keyString.search('.') != -1){
            let keyArr= keyString.split('.');
            let data=res.data.DATA;
            for(let i=0;i<keyArr.length;i++){
              data=data[keyArr[i]];
            }
            resolve({status:true,data:data,msg:''});
          }else{
            resolve({status:true,data:res.data.DATA[keyString],msg:''});
          }
        }else{
          resolve({status:true,data:res.data.DATA,msg:''});
        }
      }else{
        resolve({status:false,data:'',msg:res.data.ERROR.MESSAGE});
      }
    })
  })
}

// 個人・法人の帳簿情報の取得
const getDocumentInfoForUrl = (EMAIL,HASH_CODE = '')=>{
  return new Promise(resolve => {

        httpRequest.post('/register/request_info',{
            EMAIL: EMAIL,
            USER_REQUEST_SEQ_HASH_NO: HASH_CODE
        }).then((res)=>{
          if(res.data.STATUS == 'OK'){

            commonJs.saveLocalLowerData('user',res.data.DATA,'userRequestInfo');
            let url = commonJs.getDocumentPath(res.data.DATA)
            res.url = url
            // 法人利用者のステータスが2の場合は、法人が書籍をアップロードしたことを意味します.
            // このとき、法人利用者のステータスを積極的に更新する必要があります.更新が成功したら、S-013にジャンプします.
            if(res.data.DATA.PERSON_CORP_TYPE == 2 && res.data.DATA.APPLICANT_STATUS == 2){
              httpRequest.post('register/company_identity_submit', {
                USER_REQUEST_SEQ_HASH_NO: res.data.DATA.USER_REQUEST_SEQ_HASH_NO,
              }).then(updateRes=>{
                  if(updateRes.data.STATUS == 'OK'){
                    res.data.DATA.APPLICANT_STATUS = 5
                    let url = commonJs.getDocumentPath(res.data.DATA)
                    res.url = url
                  }
                  resolve(res);
              })
            }else{
              resolve(res);
            }
          }
          else{
            resolve(res);
          }
        })
    })
}

const getEncryptionPassword = (password)=>{
  return new Promise((resolve, reject) => {
    httpRequest.get('/common/encryption_key')
      .then((resp) => {

        if (resp.data.ERROR) {
          $cErrorDialog({
            title: '',
            left: 'cancel',
            right: 'OK',
            content: resp.data.ERROR.MESSAGE,
            cancelBtn: false
          });
          resolve();
        } else {
          let encryptionPassword = commonJs.encryptedData(atob(resp.data.DATA.ENCRYPTION_KEY),password)
          resolve({
            password: encryptionPassword,
            versionID: resp.data.DATA.SECRET_VERSION_ID
          });
        }
      })
      .catch((error) => {

        $cErrorDialog({
          title: '',
          left: 'cancel',
          right: 'OK',
          content: COMMON_JP.MES_TEXT_3,
          cancelBtn: false
        });

        resolve();
      });
  });
}


export{
    checkJpText,
    getInit,
    getDocumentInfoForUrl,
    getEncryptionPassword
}



// WEBPACK FOOTER //
// ./src/utils/common-api.js